module.exports = __webpack_public_path__ + "static/media/square-icon.3aa01ae3.svg";